module.exports = __webpack_public_path__ + "img/10.42e17460.png";